export default {
  // called by Vue.use(FirstPlugin)
  install(Vue) {
    Vue.prototype.$deleteConfirmation = function (options) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t('Delete'),
        text: options.text,
        accept: options.accept
      });
    }

    Vue.prototype.$notifySaveSuccess = function () {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
    }

    Vue.prototype.$notifySaveError = function (error) {
      this.$vs.notify({
        title: this.$t("SavingError"),
        text: error,
        color: "danger",
        iconPack: 'feather',
        icon:'icon-check'
      });
    }

    Vue.prototype.$notifySuccess = function (text) {
      this.$vs.notify({
        title: this.$t("Success"),
        text,
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
    }

    Vue.prototype.$notifyDeleteSuccess = function (text) {
      this.$vs.notify({
        title: this.$t("Success"),
        text,
        color: "success"
      });
    }

    Vue.prototype.$notifyLoadingError = function (error) {
      this.$vs.notify({
        color: "danger",
        title: this.$t("LoadingError"),
        text: error
      });
    }

    Vue.prototype.$notifyConcurrencyError = function () {
      this.$vs.notify({
        color: "danger",
        title: this.$t("ConcurrencyError"),
        text: this.$t("ConcurrencyMessage")
      });
    }

    Vue.prototype.$warn = function (message) {
      this.$vs.notify({
        color: "warning",
        title: this.$t("Warning"),
        text: message
      });
    }
  }
};